export enum SampleSortOrderType {
  NEWEST_FIRST = 'NEWEST_FIRST',
  SAMPLE_CODE = 'SAMPLE_CODE',
  LAST_CREATED_AND_SAMPLE_CODE = 'LAST_CREATED_AND_SAMPLE_CODE',
}
